/**
 * What the redesigned pages need per service beyond its id: the translation
 * key under `solutions.*` / `serviceOptions.*` / `servicePages.*`, and the
 * ambient clip in public/media (`<media>.mp4` plus its `<media>.jpg` poster,
 * generated with Higgsfield from a still of the same name).
 *
 * Order is the canonical service order, building first (web, mobile, CRM,
 * ERP, AI), then running (data, cloud, security, managed IT). Keep it in step
 * with SERVICE_OPTIONS in src/config/site.ts.
 */
export type CatalogEntry = { id: string; key: string; media: string };

export const SERVICE_CATALOG: CatalogEntry[] = [
  { id: "web-software-development", key: "webSoftwareDevelopment", media: "web" },
  { id: "mobile-app-development", key: "mobileAppDevelopment", media: "mobile" },
  { id: "crm-development", key: "crmDevelopment", media: "crm" },
  { id: "erp-systems", key: "erpSystems", media: "erp" },
  { id: "ai-automation", key: "aiAutomation", media: "ai" },
  { id: "data-databases", key: "dataDatabases", media: "data" },
  { id: "cloud-infrastructure", key: "cloudInfrastructure", media: "cloud" },
  { id: "cybersecurity-identity", key: "cybersecurityIdentity", media: "security" },
  { id: "managed-it-support", key: "managedItSupport", media: "managed" },
];

export const serviceVideo = (media: string) => ({
  src: `/media/${media}.mp4`,
  poster: `/media/${media}.jpg`,
});
